import { get, isEmpty } from "lodash";
import { ApiIO } from "../cprofit-api";
import { generateUniqueId } from "../utils/uniqueId";
import { icLoggerInstance } from "./logger";

const getLogPerfName = (uri: string, method: string | undefined) => {
  const match = uri.split("?");
  return `[API][${method ? method : "?"}]${
    match && !isEmpty(match) ? match[0] : ""
  }`;
};

const getLogPerfMessage = (
  response: Response,
  uri: string,
  method: string | undefined
) => {
  return `[API][${method ? method : "?"}][${response.ok ? "OK" : "KO"}]${uri}`;
};

export const logPerformance = async (
  apiIo: ApiIO,
  fullUri: string,
  requestInit: RequestInit
): Promise<Response> => {
  const perfKey = generateUniqueId();
  const method = requestInit.method;
  const uiscreen = get(requestInit.headers, "uiscreen");

  return await getAndStartLoggerInstance(perfKey).then(logger =>
    apiIo.configuration.fetch(fullUri, requestInit).then(response => {
      const component = "cpr-widget";
      logger
        .setCustom("app", component)
        .setCustom("component", component)
        .setCustom("host", location.host)
        .setCustom("status", response.status)
        .setCustom("statusText", response.statusText)
        .setCustom("type", response.type)
        .setCustom("method", method)
        .setCustom("uiscreen", uiscreen)
        // this is a kind of workaround. Hopefully overriding properly the value will be implemented  https://sgithub.fr.world.socgen/ic/ic-web-libs/issues/23
        .setCustom("correlationId", apiIo.correlationId)
        .performance(
          getLogPerfName(fullUri, method),
          getLogPerfMessage(response, fullUri, method),
          perfKey,
          component
        );
      return response;
    })
  );
};

function getAndStartLoggerInstance(perfKey: string): Promise<any> {
  // tslint:disable-next-line:prefer-promise-shorthand
  return new Promise((resolve: any, reject: any) => {
    resolve(icLoggerInstance.startPerformanceMeasure(perfKey));
  });
}
